module.exports = __webpack_public_path__ + "img/easybase-xs.b3baf719.webp";